import classNames from 'classnames';
import { ImageShape } from '../../../lib/types';
import Image from '../../shared/Image';
import Responsive from '../../shared/Responsive';
import Typografed from '../../shared/Typografed';

export interface TextWithImageSectionProps {
    title: string;
    subtitle?: string;
    text?: string;
    description?: string;
    link?: {
        name: string;
        href: string;
    } | null;
    img?: ImageShape | null;
}

type Props = React.HTMLAttributes<HTMLElement> & {
    textWithImageSectionProps: TextWithImageSectionProps;
};

const TextWithImageSection = ({ textWithImageSectionProps, children, ...props }: Props) => {
    const image = textWithImageSectionProps.img;

    return (
        image && (
            <section {...props} className={classNames('text-with-image__section', props.className)}>
                <div className="text-with-image__wrapper wrapper">
                    <div className="text-with-image__block text-with-image__block-left">
                        <div className="text-with-image__block-left__wrapper">
                            <div className="text-with-image__block-top">
                                <div className="text-with-image__title h3">
                                    <Typografed>{textWithImageSectionProps.title}</Typografed>
                                </div>
                            </div>
                            {children}
                        </div>
                    </div>

                    <div className="text-with-image__block text-with-image__block--right">
                        <Responsive className="text-with-image__img-wrapper">
                            {image && (
                                <Image
                                    className="text-with-image__img"
                                    src={image.src}
                                    alt={image.alt || ''}
                                    title={image.title}
                                    width={image.width}
                                    height={image.height}
                                    sizes="(max-width: 1199px) 50vw, 30vw"
                                />
                            )}
                        </Responsive>
                    </div>
                </div>
            </section>
        )
    );
};

export default TextWithImageSection;
